import * as React from 'react';
import { useGhostText_unstable } from './useGhostText';
import { renderGhostText_unstable } from './renderGhostText';
import { useGhostTextStyles_unstable } from './useGhostTextStyles.styles';
import type { GhostTextProps } from './GhostText.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GhostText component - TODO: add more docs
export const GhostText: ForwardRefComponent<GhostTextProps> = React.forwardRef((props, ref) => {
  const state = useGhostText_unstable(props, ref);

  useGhostTextStyles_unstable(state);
  return renderGhostText_unstable(state);
});

GhostText.displayName = 'GhostText';
